/*
 * @Date: 2023-10-17 15:23:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-03-18 23:42:05
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/voiceRoomIM.js
 * @Description: 語音房im消息管理
 * 初始化imsdk
 * 登录im
 * 获取房间详情
 * 加入群聊
 * 设置当前用户信息
 * 获取群主信息
 * 获取主持人信息
 * 获取麦位信息
 * 新用户进入房间-弹窗提示
 * 麦位变化-上麦-下麦-更新麦位信息
 */
import Vue from 'vue';
import TIM from '@tencentcloud/chat';
// import TIMUploadPlugin from 'tim-upload-plugin';
import * as $http from '@/axios';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import { ChatMessage } from '@/components/VoiceRoom/chatProvider';
import { formatAwsUrl } from '@/components/VoiceRoom/util';
import util from '@/utils/util';
import { getOnlineUsers } from '@/api/voice-room';
// import SeatProvider from './seatProvider';

const VoiceRoomIM = Vue.observable({
  options: {},
  tim: {},
  messageList: [],
  members: [],
  newJoinMember: {
    profile: null,
    dressup: null
  },
  newJoinMemberList: [],
  userInfo: {},
  groupID: undefined,
  groupJoinType: undefined,
  operatorID: undefined,
  isJoin: true,
  hasEntryAnimation: true, //是否允许进场动画
  hasSendGiftAnimation: true, // 是否允许送礼动画
  getOnlineUsersLoading: false,
  login: () => {},
  joinGroup: () => {},
  getGroupList: () => {},
  updateUserProfile: () => {},
  sendMessage: () => {},
  IM_READY: () => {},
  quitGroup: () => {},
  isInGroup: () => {},
  getGroupMember: () => {},
  getGroupProfile: () => {},
  sendImageMessage: () => {},
  sdkReady: () => {},
  onMessageReceived: () => {}
});

VoiceRoomIM.options = {
  SDKAppID: process.env.VUE_APP_IM_SDK_ID
};

// VoiceRoomIM.tim = TIM.create(VoiceRoomIM.options); // SDK 实例通常用 tim 表示
// // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel https://web.sdk.qcloud.com/im/doc/zh-cn/SDK.html#setLogLevel 接口的说明</a>
// VoiceRoomIM.tim.setLogLevel(4); // 普通级别，日志量较多，接入时建议使用
// // tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

// // 注册腾讯云即时通信 IM 上传插件
// VoiceRoomIM.tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });

VoiceRoomIM.onMessageReceived = event => {
  if (!VoiceRoomIM.isJoin) {
    return '';
  }
  console.log(event);
  const list = event.data.filter(item => {
    return (
      item.conversationType == 'GROUP' &&
      item.conversationID == 'GROUP' + VoiceRoomIM.groupID
    );
  });
  sortOutMessage(list);
};

/**
 * @description: 归类消息
 * @return {*}
 */
const sortOutMessage = async (list) => {
  list.forEach(async item => {
    try {
      const { payload, nick, from } = item;
      const { data } = payload;
      if (payload.operatorID) {
        VoiceRoomIM.groupJoinType = payload.groupJoinType;
        VoiceRoomIM.operatorID = payload.operatorID;
      }
      if (payload.groupJoinType === 0) {
        VoiceRoomIM.userLeaveRoom(
          new ChatMessage({
            nickName: nick,
            action: 'leaveRoom',
            message: '離開了'
          })
        );
      } else {
        if (data) {
          const { ExtraData, command, message } = JSON.parse(data);
          console.log('data', JSON.parse(data));
          if (ExtraData) {
            const command = ExtraData.command;
            if (command === 'UpdateUsers' && ExtraData.message) {
              const userList = ExtraData.message.data;
              VoiceRoomIM.updateNewJoinMember(
                userList,
                VoiceRoomIM.groupJoinType,
                VoiceRoomIM.operatorID
              );
            }
            if (command === 'OnSendGift') {
              const messageData = ExtraData.message;
              let receiveName = '';
              for (let i = 0; i < messageData.sendPlayerUserUuids.length; i++) {
                const member = await VoiceRoomIM.getImMemberProfile(messageData.sendPlayerUserUuids[i]);
                console.log('OnSendGift',member);
                if (member) {
                  receiveName = receiveName + member.nickName + ',';
                }
              }
              // messageData.sendPlayerUserUuids.forEach(async (item) => {
              //   const member = await VoiceRoomIM.getImMemberProfile(item);
              //   console.log('OnSendGift',member);
              //   if (member) {
              //     receiveName = receiveName + member.nickName + ',';
              //   }
              // });
              console.log('OnSendGift',receiveName);
              if (receiveName.slice(-1) === ',') {
                // 删除最后一个字符
                receiveName = receiveName.slice(0, -1);
              }
              VoiceRoomIM.addNewMessage(
                new ChatMessage({
                  action: 'OnSendGift',
                  userId: messageData.userUuid,
                  nickName: messageData.userNickname,
                  message: receiveName,
                  giftInfo: messageData,
                  level: messageData.consumerLevel
                })
              );
              if (VoiceRoomIM.hasSendGiftAnimation) {
                VoiceRoomEventEmitter.emit(
                  VoiceRoomEvent.addVideoMessage,
                  messageData.giftAnimationUrl
                );
              }
            }
            if (command === 'UpdateAskingMicQueue') {
              VoiceRoomEventEmitter.emit(
                VoiceRoomEvent.updateAskingMicQueue,
                ExtraData.message.bQueueNum + ExtraData.message.cQueueNum
              );
            }
            if (command === 'OnDressupChange') {
              VoiceRoomIM.updateGroupMemberProfile(ExtraData.message.uuid);
            }
            if (command === 'OnAdminChange') {
              VoiceRoomEventEmitter.emit(VoiceRoomEvent.OnAdminChange);
            }
            if (command === 'OnSeatChange' && ExtraData.message) {
              VoiceRoomEventEmitter.emit(
                VoiceRoomEvent.onSeatChange,
                ExtraData.message
              );
            }
            if (command === 'OnMicChange') {
              VoiceRoomEventEmitter.emit(
                VoiceRoomEvent.onMicChange,
                ExtraData.message
              );
            }
          }

          if (command) {
            if (command === 'imageReceive') {
              const messageData = JSON.parse(message);
              VoiceRoomIM.addNewMessage(
                new ChatMessage({
                  action: 'imageReceive',
                  userId: messageData.uuid,
                  nickName: messageData.nickname,
                  message: messageData.content
                })
              );
            } else if (command === 'emojiReceive') {
              const messageData = JSON.parse(message);
              VoiceRoomIM.addNewMessage(
                new ChatMessage({
                  action: 'emojiReceive',
                  userId: messageData.uuid,
                  nickName: messageData.nickname,
                  message: messageData.content,
                  ...messageData
                })
              );
            } else {
              const commandData = JSON.parse(command);
              const { action } = commandData;
              if (action === 'normal') {
                VoiceRoomIM.addNewMessage({
                  ...commandData,
                  message,
                  userId: from
                });
              }
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  });
};

VoiceRoomIM.addNewMessage = message => {
  VoiceRoomEventEmitter.emit(
    VoiceRoomEvent.addNewMessage,
    new ChatMessage(message)
  );
};

/**
 * @description: 更新新加入的群组成员
 * @param {*} list
 * @param {*} groupJoinType
 * @param {*} operatorID
 * @return {*}
 */
VoiceRoomIM.updateNewJoinMember = async (list, groupJoinType, operatorID) => {
  const user = list.find(item => {
    return operatorID === item.uuid;
  });
  if (user) {
    if (groupJoinType === 1) {
      await VoiceRoomIM.updateGroupMemberProfile(operatorID);
      const member = await VoiceRoomIM.getMemberProfile(operatorID);
      VoiceRoomIM.newJoinMember = member;
      VoiceRoomIM.newJoinMemberList.push(VoiceRoomIM.newJoinMember);
      VoiceRoomIM.addNewMessage(
        new ChatMessage({
          nickName: user.nickname,
          action: 'userJoinRoom',
          message: '進入直播間'
        })
      );
      if (VoiceRoomIM.hasEntryAnimation) {
        const dressup = VoiceRoomIM.getMemberDressUp(operatorID);
        if (dressup && dressup.MOUNT && dressup.MOUNT.url) {
          VoiceRoomEventEmitter.emit(
            VoiceRoomEvent.addVideoMessage,
            formatAwsUrl(dressup.MOUNT.url)
          );
        }
      }
      VoiceRoomEventEmitter.emit(VoiceRoomEvent.joinRoom);
    }
  }
  groupJoinType = undefined;
  operatorID = undefined;
};

/**
 * @description: 用戶離開房間
 * @param {*} user
 * @return {*}
 */
VoiceRoomIM.userLeaveRoom = user => {
  VoiceRoomEventEmitter.emit(VoiceRoomEvent.leaveRoom, user);
};

/**
 * @description: 登录im
 * @param {*} userInfo
 * @return {*}
 */
VoiceRoomIM.login = async userInfo => {
  try {
    const { data } = await $http.get('/im/auth/sign');
    const { data: responseData } = await VoiceRoomIM.tim.login({
      userID: userInfo.uuid,
      userSig: data
    });
    return responseData;
  } catch (error) {
    alert('登录失败');
    return Promise.reject(error);
  }
};
/**
 * @description: 退出群聊
 * @param {*} groupID
 * @return {*}
 */
VoiceRoomIM.quitGroup = async groupID => {
  try {
    const res = await VoiceRoomIM.tim.quitGroup(groupID);
    VoiceRoomIM.isJoin = false;
    return res;
  } catch (error) {
    console.log(error);
  }
};

/**
 * @description: 查询是否在群组里
 * @param {*} groupID
 * @param {*} userId
 * @return {*}
 */
VoiceRoomIM.isInGroup = async (groupID, userId) => {
  try {
    const list = await VoiceRoomIM.getGroupMember(groupID);
    return list.find(item => item.userID === userId);
  } catch (error) {
    console.log(error);
  }
};

/**
 * @description: 获取群成员
 * @param {*} groupID
 * @param {*} userId
 * @return {*}
 */
VoiceRoomIM.getGroupMember = async groupID => {
  try {
    const { data } = await VoiceRoomIM.tim.getGroupMemberList({
      groupID: groupID,
      count: 100,
      offset: 0
    });
    if (data) {
      return data.memberList;
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * @description: 查询自己的资料
 * @return {*}
 */
VoiceRoomIM.getMyProfile = async () => {
  try {
    const res = await VoiceRoomIM.tim.getMyProfile();
    console.log(res);
  } catch (error) {
    console.log(error);
  }
};

/**
 * @description: 獲取群成員資料
 * @return {*}
 */
VoiceRoomIM.getGroupMemberProfile = async () => {
  if (VoiceRoomIM.getOnlineUsersLoading) {
    return;
  }
  try {
    VoiceRoomIM.getOnlineUsersLoading = true;
    const { data } = await getOnlineUsers({ roomUid: VoiceRoomIM.groupID });
    VoiceRoomIM.members = data;
    VoiceRoomIM.getOnlineUsersLoading = false;
  } catch (error) {
    VoiceRoomIM.getOnlineUsersLoading = false;
    console.log(error);
  }
};

/**
 * @description: 更新房间成员信息
 * @param {*} userId
 * @return {*}
 */
VoiceRoomIM.updateGroupMemberProfile = async userId => {
  const member = await VoiceRoomIM.getImMemberProfile(userId);
  if (member && member.userUuid) {
    const index = VoiceRoomIM.members.findIndex(
      item => item.userUuid === userId
    );
    console.log(VoiceRoomIM.members, member);
    if (index === -1) {
      VoiceRoomIM.members.push(member);
    } else {
      VoiceRoomIM.members[index] = member;
    }
  }
  // await VoiceRoomIM.getGroupMemberProfile();
};

/**
 * @description: 獲取用戶資料
 * @param {*} userId
 * @return {*}
 */
// VoiceRoomIM.getMemberProfile = async userId => {
//   const member = VoiceRoomIM.members.find(item => item.userUuid === userId);
//   if (member) {
//     return member;
//   } else {
//     await VoiceRoomIM.updateGroupMemberProfile();
//     return VoiceRoomIM.members.find(item => item.userUuid === userId);
//   }
// };
VoiceRoomIM.getImMemberProfile = async userId => {
  const { data } = await VoiceRoomIM.tim.getUserProfile({
    userIDList: [userId]
  });
  console.log('getMemberProfile', data, userId);
  const detail = data[0];
  const userLevelObj = detail.profileCustomField.find(
    item => item.key === 'Tag_Profile_Custom_UserLev'
  );
  const level = userLevelObj ? userLevelObj['value'] : null;
  const pfpFrameObj = detail.profileCustomField.find(
    item => item.key === 'Tag_Profile_Custom_pfpFrame'
  );
  const pfpFrame = pfpFrameObj ? pfpFrameObj['value'] : null;
  // let pfpFrameUrl = '';
  // if (pfpFrame) {
  //   pfpFrameUrl = pfpFrame ? JSON.parse(pfpFrame).url : '';
  // }
  const bubble_BOXObj = detail.profileCustomField.find(
    item => item.key === 'Tag_Profile_Custom_dressup'
  );
  const bubble_BOX = bubble_BOXObj ? bubble_BOXObj['value'] : null;
  // let bubble_BOXUrl = '';
  // if (bubble_BOX) {
  //   bubble_BOXUrl = bubble_BOX ? JSON.parse(bubble_BOX).BUBBLE_BOX.url : '';
  // }
  // console.log(bubble_BOXUrl,JSON.parse(bubble_BOX),JSON.parse(pfpFrame));

  return {
    roomUid: VoiceRoomIM.groupID,
    seatIndex: null,
    userUuid: detail.userID,
    nickName: detail.nick,
    avatarURL: detail.avatar,
    sex: detail.gender,
    userLevel: level,
    spendAmount: 0,
    mic: null,
    rankingScore: 0,
    pfpFrame: pfpFrame,
    bubble_BOX: bubble_BOX
    // pfpFrame: pfpFrameUrl,
    // bubble_BOX: bubble_BOXUrl
  };
};
VoiceRoomIM.getMemberProfile = async userId => {
  const member = VoiceRoomIM.members.find(item => item.userUuid === userId);
  if (member) {
    return member;
  } else {
    try {
      const member = await VoiceRoomIM.getImMemberProfile(userId);
      VoiceRoomIM.members.push(member);
      //  {"roomUid":"20231012004","seatIndex":null,"userUuid":"1000518","nickname":"醉了好","avatarURL":"https://resource.funplus.social/user-static/49f35e22-aa6c-4c5c-aa17-dd5f544fa1396337067608568951349.png",
      // "sex":"Male","userLevel":4,"spendAmount":13355,"mic":null,"uniqueMic":null,"rankingScore":0,"pfpFrame":null,"time":null,"bubble_BOX":null}
      return member;
    } catch (error) {
      console.log(error);
    }
  }
};

VoiceRoomIM.findMemberProfile = userId => {
  return VoiceRoomIM.members.find(item => item.userUuid === userId);
};
VoiceRoomIM.getMemberDressUp = userId => {
  const user = VoiceRoomIM.findMemberProfile(userId);
  if (user && user.bubble_BOX) {
    return JSON.parse(user.bubble_BOX);
  } else {
    return null;
  }
};
VoiceRoomIM.getMemberPfpFrame = userId => {
  const user = VoiceRoomIM.findMemberProfile(userId);
  if (user && user.pfpFrame) {
    return JSON.parse(user.pfpFrame);
  } else {
    return null;
  }
};
VoiceRoomIM.getMemberLevel = userId => {
  const user = VoiceRoomIM.findMemberProfile(userId);
  return user && user.userLevel ? user.userLevel : null;
};

/**
 * @description: 获取群资料
 * @param {*} groupID
 * @return {*}
 */
VoiceRoomIM.getGroupProfile = async groupID => {
  try {
    const res = await VoiceRoomIM.tim.getGroupProfile({
      groupID: groupID,
      groupCustomFieldFilter: undefined
    });
    console.log(res);
    return res;
  } catch (error) {
    console.log(error);
  }
};

/**
 * @description: 加入群组
 * @param {*} groupID
 * @return {*}
 */
VoiceRoomIM.joinGroup = async inputGroupID => {
  try {
    const data = await VoiceRoomIM.tim.joinGroup({ groupID: inputGroupID });
    VoiceRoomIM.groupID = inputGroupID;
    VoiceRoomIM.isJoin = true;
    return data;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: VoiceRoomIM.groupID, fun: 'VoiceRoomIM.joinGroup' },
      error
    );
    alert('加入群聊失败');
    throw new Error('加入群聊失败');
  }
};

/**
 * @description: 获取加入的群组列表
 * @return {*}
 */
VoiceRoomIM.getGroupList = async () => {
  try {
    const imResponse = await VoiceRoomIM.tim.getGroupList();
    if (imResponse.data.groupList) {
      return imResponse.data.groupList;
    }
  } catch (error) {
    return Promise.reject(false);
  }
};

/**
 * @description: 更新个人资料
 * @return {*}
 */
VoiceRoomIM.updateUserProfile = userProfile => {
  VoiceRoomIM.tim.updateMyProfile(
    userProfile
    //   {
    //   nick: userInfo.nickname,
    //   avatar: userInfo.avatarUrl,
    //   allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
    // }
  );
};

/**
 * @description:发送消息
 * @param {*} payload
 * @return {*}
 */
VoiceRoomIM.sendMessage = async payload => {
  try {
    const { data, description, extension } = payload;
    if (data && data.command) {
      if (typeof data.command === 'object') {
        data.command = JSON.stringify(data.command);
      }
      if (data.command == 'emojiReceive') {
        data.message = JSON.stringify(data.message);
      }
      if (data.command == 'imageReceive') {
        data.message = JSON.stringify(data.message);
      }
    }
    //创建自定义消息。
    const message = VoiceRoomIM.tim.createCustomMessage({
      to: VoiceRoomIM.groupID, //群组id
      conversationType: TIM.TYPES.CONV_GROUP, //类型为群组会话
      payload: {
        data: JSON.stringify(data),
        description: description,
        extension: extension
      }
    });
    await VoiceRoomIM.tim.sendMessage(message);
    return true;
  } catch (error) {
    if (error && error.code && error.code == 10017) {
      throw '你已被禁言';
    } else {
      throw new Error(error);
    }
  }
};

let IM_SDK_READY;

/**
 * @description: imSDK是否已准备好
 * @param {*} new
 * @return {*}
 */
VoiceRoomIM.IM_READY = new Promise(res => {
  IM_SDK_READY = function() {
    console.log('IM_SDK_READY');
    res();
  };
});

/**
 * @description: imSdk是否已加载
 * @return {*}
 */
VoiceRoomIM.sdkReady = () => {
  console.log('VoiceRoomIM.sdkReady');
  IM_SDK_READY();
};

VoiceRoomIM.initTim = tim => {
  VoiceRoomIM.tim = tim;
};

//上麥通過
VoiceRoomEventEmitter.on(VoiceRoomEvent.userEnterSeat, async user => {
  VoiceRoomIM.addNewMessage(
    new ChatMessage({
      nickName: user.nickname,
      action: 'userEnterSeat',
      message: '上麥了'
    })
  );
});
export default VoiceRoomIM;
